export default function LoadingSpinner() {
    return (
        <div className="container text-center py-10">
            <h2>Server spining up. Please wait.</h2>
        </div>
    )
}
